import { DateObject } from "react-multi-date-picker";
import { long, TwoDigit, numeric, NA, short } from "../Constant";

export const dateConversion = (
  date: Date | string | DateObject | null | undefined,
  showWeekDay: boolean = false,
  showYear: boolean = true,
  isShortMonth: boolean = true
) => {
  if (!date) {
    return NA;
  }

  const jsDate =
    date instanceof DateObject
      ? date.toDate()
      : typeof date === "string"
      ? new Date(date)
      : date;

  if (isNaN(jsDate.getTime())) return NA;

  const formattedDate = new Date(jsDate).toLocaleDateString("en-Us", {
    year: numeric,
    month: isShortMonth ? short : "long",
    day: numeric,
    weekday: short,
  });
  const [weekday, day, month, year] = formattedDate.replace(",", "").split(" ");

  return `${showWeekDay ? `${weekday},` : ""}${" "}${month?.replace(
    ",",
    ""
  )} ${day} ${showYear ? `${year}` : ""} `;
};

export const getFormattedDateTime = (paramDate?: string) => {
  const now = paramDate ? new Date(paramDate) : new Date();

  // Day of the month with suffix
  const day = now.getDate();
  const daySuffix = (date: any) => {
    if (date > 3 && date < 21) return "th";
    switch (date % 10) {
      case 1:
        return "st";
      case 2:
        return "nd";
      case 3:
        return "rd";
      default:
        return "th";
    }
  };

  // Full month name
  const month = now.toLocaleString("en-US", { month: long });

  // Full weekday name
  const weekday = now.toLocaleString("en-US", { weekday: long });

  // Full year
  const year = now.getFullYear();

  // 12-hour formatted time
  const time = now.toLocaleString("en-US", {
    hour: TwoDigit,
    minute: TwoDigit,
    second: TwoDigit,
    hour12: true,
  });

  const formattedDay = daySuffix(day);
  return { day, formattedDay, month, weekday, year, time };
};

export const formattedYMDDate = (date: string | Date) => {
  if (date) {
    return new Date(date).toLocaleDateString("en-Ca", {
      year: numeric,
      month: TwoDigit,
      day: TwoDigit,
    });
  } else {
    return new Date().toLocaleDateString("en-Ca", {
      year: numeric,
      month: TwoDigit,
      day: TwoDigit,
    });
  }
};

export const formatMYDate = (date?: string | Date) => {
  const d = date ? new Date(date) : new Date();
  const month = String(d.getMonth() + 1).padStart(2, "0");
  const year = d.getFullYear();
  return `${month}-${year}`;
};

export const isWithinLastNDays = (dateStr: string, n: number): boolean => {
  const date = new Date(dateStr);
  const today = new Date();
  date.setHours(0, 0, 0, 0);
  today.setHours(0, 0, 0, 0);

  const diff = today.getTime() - date.getTime();
  const diffInDays = diff / (1000 * 60 * 60 * 24);

  return diffInDays <= n;
};

export function getTodayDateTime(): string {
  const today: Date = new Date();

  const yyyy: number = today.getFullYear();
  const mm: string = String(today.getMonth() + 1).padStart(2, "0"); // Months start at 0
  const dd: string = String(today.getDate()).padStart(2, "0");

  const hh: string = String(today.getHours()).padStart(2, "0");
  const min: string = String(today.getMinutes()).padStart(2, "0");
  const ss: string = String(today.getSeconds()).padStart(2, "0");

  return `${yyyy}-${mm}-${dd}_${hh}-${min}-${ss}`;
  // e.g., 2025-09-19_17-32-45
}
